import { DateTime } from "@tento-chrono";
import { Result } from "@tento-core/result";
import { ResponseError } from "@tento-core/typed-api";
import { Storybook } from "@tento-ui/ui/storybook";
import { Network } from "../@generated/network";
import { CreateApiKeyPage } from "./create-api-key-page";

export class CreateApiKeyPageStoryBook extends Storybook.Default {
  title(): string {
    return "Create API key";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Create and copy a sample key",
        render: () => CreateApiKeyPage.make().bind({
          onCreate: async () => Result.ok<Network.CreatedApiKeyResponse, ResponseError>({
            token: "lona_ak_example_not_a_real_credential",
            expiresAt: DateTime.utc.now(),
          }),
          onDone: null,
        }),
      },
      {
        title: "Request refused",
        render: () => CreateApiKeyPage.make().bind({
          onCreate: async () => Result.err<ResponseError, Network.CreatedApiKeyResponse>({
            code: 403,
            reason: "Generate API keys from the same Lona browser origin",
            details: "",
            inner: null,
          }),
          onDone: null,
        }),
      },
    ];
  }
}
